import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { socket } from "../helpers/socketInstance";
import Chart from "react-apexcharts";
import { FaTruck, FaBoxOpen, FaParking, FaSignOutAlt } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dashboard.css";

const Dashboard = () => {
    const navigate = useNavigate();
    const [vehicleFilter, setVehicleFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");

    useEffect(() => {
        const room = localStorage.getItem("VehicleEntry-Room");
    if (room) {
        console.log("🔌 Joining room:", room);
        socket.emit("joinRoom", room);
    }
        socket.on("connect", () => console.log("Connected to Socket.IO server!"));
        if(localStorage.getItem("VehicleEntry-Room")){
            socket.emit("joinRoom", localStorage.getItem("VehicleEntry-Room"));
           
        }
        socket.on("vehicle-entry", (data) => {
            console.log("📥 vehicle-entry received:", data);
            navigate('/vehicleEntry', { state: { vehicleData: data } });
        });
        return () => socket.off("vehicle-entry");
    }, [navigate]);

    const stats = [
        { title: "Entry in Progress", count: 10, color: "#FF5733", icon: <FaTruck className="entry-icon" size={24} /> },
        { title: "Unloading", count: 3, color: "#FF8C00", icon: <FaBoxOpen className="unloading-icon" size={24} /> },
        { title: "Parking", count: 5, color: "#17A2B8", icon: <FaParking className="park-icon" size={24} /> },
        { title: "Exiting", count: 2, color: "#007BFF", icon: <FaSignOutAlt className="exit-icon" size={24} /> },
    ];

    const truckData = [
        { sl: 1, vehicle: "12305439", time: "08:15:30", status: "Loading" },
        { sl: 2, vehicle: "F2345U38", time: "09:42:18", status: "Waiting" },
        { sl: 3, vehicle: "G6789H12", time: "10:27:05", status: "Waiting" },
        { sl: 4, vehicle: "H8910I34", time: "12:05:52", status: "Arrived" },
        { sl: 5, vehicle: "J1234K56", time: "18:10:12", status: "Exit" },
        { sl: 6, vehicle: "L7890M12", time: "15:52:40", status: "Loading" },
    ];

    const filteredData = truckData.filter(truck =>
        (statusFilter === "All" || truck.status === statusFilter) &&
        (vehicleFilter === "" || truck.vehicle.includes(vehicleFilter))
    );

    const healthData = [
        { label: "ALPR", success: 4, failure: 1 },
        { label: "RFID", success: 3, failure: 2 },
        { label: "Handheld", success: 5, failure: 0 },
        { label: "Display", success: 5, failure: 0 },
        { label: "Boom Barrier", success: 5, failure: 0 },
        { label: "USS", success: 4, failure: 1 }
    ];

    return (
        <div className="dashboard py-2 px-0">
            {/* Status Cards */}
            <div className="row mb-4">
                {stats.map((stat, index) => (
                    <div key={index} className="col-md-3">
                        <div className="card shadow-sm p-3 border-0 rounded-lg position-relative" style={{ backgroundColor: "#fff", borderRadius: "12px" }}>
                            <span className="position-absolute top-0 end-0 m-3 d-flex align-items-center justify-content-center"
                                style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: stat.color }}>
                                {stat.icon}
                            </span>
                            <h6 className="text-muted">{stat.title}</h6>
                            <h3 className="fw-bold">{stat.count}</h3>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row mx-0 g-2">
                {/* Live Truck Details */}
                <div className="col-md-5">
                    <div className="card">
                        <div className="card-header bg-primary text-white">Live Truck Details</div>
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between mb-4">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search Vehicle"
                                    value={vehicleFilter}
                                    onChange={(e) => setVehicleFilter(e.target.value)}
                                    style={{ maxWidth: "150px" }}
                                />
                                <select
                                    className="form-select form-select-sm"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    style={{ maxWidth: "150px" }}
                                >
                                    <option value="All">All</option>
                                    <option value="Loading">Loading</option>
                                    <option value="Waiting">Waiting</option>
                                    <option value="Arrived">Arrived</option>
                                    <option value="Exit">Exit</option>
                                </select>
                            </div>
                            <table className="table text-center table-sm">
                                <thead className="table">
                                    <tr>
                                        <th>Sl. No</th>
                                        <th>Vehicle No.</th>
                                        <th>In Time</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((truck, index) => (
                                        <tr key={index}>
                                            <td>{truck.sl}</td>
                                            <td>{truck.vehicle}</td>
                                            <td>{truck.time}</td>
                                            <td>
                                                <button
                                                    className={`btn btn-sm ${truck.status === "Loading"
                                                            ? "btn-primary"
                                                            : truck.status === "Waiting"
                                                                ? "btn-warning text-dark"
                                                                : truck.status === "Arrived"
                                                                    ? "btn-success"
                                                                    : "btn-danger"
                                                        }`}
                                                >
                                                    {truck.status}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredData.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-muted">No results found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Hardware Devices Health Status */}
                <div className="col-md-7">
                    <div className="card">
                        <div className="card-header bg-primary text-white text-center">
                            Hardware Devices Health Status
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {healthData.map((device, index) => (
                                    <div key={index} className="col-md-4 d-flex justify-content-center mb-4">
                                        <Chart
                                            options={{
                                                chart: { type: "donut" },
                                                colors: ["#28a745", "#dc3545"],
                                                stroke: { width: 1 },
                                                plotOptions: {
                                                    pie: {
                                                        donut: {
                                                            size: "60%",
                                                            labels: {
                                                                show: true,
                                                                total: {
                                                                    show: true,
                                                                    label: device.label,
                                                                    color: "#333",
                                                                    fontSize: "14px",
                                                                    fontWeight: "bold"
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                dataLabels: {
                                                    enabled: true,
                                                    formatter: (val, { seriesIndex }) =>
                                                        seriesIndex === 0
                                                            ? `${device.success}`
                                                            : `${device.failure}`,
                                                    style: {
                                                        colors: ["#fff", "#fff"],
                                                        fontSize: "14px",
                                                        fontWeight: "bold"
                                                    }
                                                },
                                                legend: { show: false }
                                            }}
                                            series={[device.success, device.failure]}
                                            type="donut"
                                            height={170}
                                            width={170}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="text-center mb-3">
                            <span style={{ color: "#28a745", fontWeight: "bold", paddingRight: "10px" }}>🟢 Success</span>
                            <span style={{ color: "#dc3545", fontWeight: "bold" }}>🔴 Failure</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
};

export default Dashboard;
